import { IEventRule } from '@src/emp-3.0/types/mapped-event';
import { ECalculationType, EOccurrenceType, EWithinUnitType } from '@src/emp-3.0/types';
import { mappedEventDeployedStatus } from '@src/common/constant/enum';

export enum EMetricBuilderAction {
  NEW,
  EDIT,
}

export enum EMetricType {
  TIME_INTERVAL,
  SESSIONS,
  COMPOSITE,
}

export enum EPairType {
  FIRST_FIRST = 'first_first',
  LAST_FIRST = 'last_first',
}

// Metric builder form initial value type
export type TInitialValues = {
  metricType: EMetricType;
  metricName: string;
  description: string;
  calculation: ECalculationType;
  firstEvent: number;
  secondEvent: number;
  withinRange: number;
  withinUnit: EWithinUnitType;
  pairingLogic: EPairType;
  occurrenceType: EOccurrenceType;
  need_distribution: 1 | 0;
  distribution: {
    max_value?: number;
    min_value?: number;
  };
};

export interface IMappedEvent {
  related_flows: any;
  related_metrics: any;
  event_id?: number | null;
  event_name: string;
  event_category: string;
  description?: string;
  rules: IEventRule[][];
  status?: mappedEventDeployedStatus;
}

export interface IActivateMappedEventPayload extends IMappedEvent {
  need_deploy?: boolean;
}
